import { Theme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(({
  palette,
  fontWeights,
  fontFamilies,
}: Theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 'fit-content',
    border: 'none',
    fontFamily: fontFamilies.primary,
    fontWeight: fontWeights.regular,
    fontSize: '1rem',
    lineHeight: 1.5,
    letterSpacing: -0.32,
    textDecoration: 'none',
    textTransform: 'unset',
    '&:focus-visible': {
      outlineWidth: 1,
      outlineStyle: 'dashed',
      outlineOffset: 2,
    },
    '&.dark': {
      padding: '1rem 1.875rem',
      borderRadius: '2.5rem',
      background: palette.primary.dark,
      color: palette.common.white,
      '&:focus-visible': {
        outlineColor: palette.primary.dark,
      },
    },
    '&.light': {
      padding: '1rem 1.875rem',
      border: `1px solid ${palette.primary.dark}`,
      borderRadius: '2.5rem',
      background: palette.primary.light,
      color: palette.primary.dark,
      '&:focus-visible': {
        outlineColor: palette.primary.light,
      },
    },
  },
}));
